module.exports = __webpack_public_path__ + "static/media/stephen-leonardi-WKBlYfFzsZU-unsplash.ad39a26a.jpg";